import dayjs from "dayjs";

type EntriesExportFileNameParams = {
  /** Number of entries in the file. */
  count: number;
  /** Whether the file holds every entry or only the ones picked in the table. */
  scope: "all" | "selected";
};

/**
 * e.g. `entries_2026-09-21_18-45_120-entries_all.csv`
 * date, hour (local time), entry count, then what was exported.
 */
export const getEntriesExportFileName = ({
  count,
  scope,
}: EntriesExportFileNameParams): string => {
  const timestamp = dayjs().format("YYYY-MM-DD_HH-mm");
  const countLabel = `${count}-${count === 1 ? "entry" : "entries"}`;

  return `entries_${timestamp}_${countLabel}_${scope}.csv`;
};
